// src/modules/requerimiento/utils/categoriaPendiente.js
// Qué tiene que hacer Sistemas con un módem en espera de plataforma. Misma clasificación que
// CATEGORIA_ESPERA_SQL del backend (campo `categoria` de cada fila y filtro `categoria` del listado).
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import BuildOutlinedIcon from "@mui/icons-material/BuildOutlined";
import SwapHorizIcon from "@mui/icons-material/SwapHoriz";
import AssignmentReturnOutlinedIcon from "@mui/icons-material/AssignmentReturnOutlined";
import AssignmentOutlinedIcon from "@mui/icons-material/AssignmentOutlined";

export const CATEGORIAS_PENDIENTE = [
  { clave: "adicion", etiqueta: "Adición", color: "#16A34A", Icono: AddCircleOutlineIcon, queHacer: "Cargar en la plataforma y verificar que reporte" },
  { clave: "mantenimiento", etiqueta: "Mantenimiento", color: "#F59E0B", Icono: BuildOutlinedIcon, queHacer: "Verificar que siga reportando" },
  // Módem nuevo que reemplazó a otro en un mantenimiento (estado_pendiente 'Remplazo Adicion').
  { clave: "reemplazo", etiqueta: "Reemplazo", color: "#8B5CF6", Icono: SwapHorizIcon, queHacer: "Cambiar el equipo en la plataforma: quitar el anterior y cargar el nuevo" },
  { clave: "devolucion", etiqueta: "Devolución", color: "#DC2626", Icono: AssignmentReturnOutlinedIcon, queHacer: "Dar de baja de la plataforma" },
  { clave: "otro", etiqueta: "Otro", color: "#94A3B8", Icono: AssignmentOutlinedIcon, queHacer: "Revisar en la plataforma" },
];

const POR_CLAVE = Object.fromEntries(CATEGORIAS_PENDIENTE.map((c) => [c.clave, c]));

/** Usa la del backend; si no viene (backend viejo), se deduce del tipo como lo hace el backend. */
export function categoriaDe(row) {
  if (POR_CLAVE[row?.categoria]) return POR_CLAVE[row.categoria];
  const tipo = String(row?.tipo_req || "");
  if (String(row?.estado_pendiente || "").trim() === "Remplazo Adicion") return POR_CLAVE.reemplazo;
  if (/adici/i.test(tipo)) return POR_CLAVE.adicion;
  if (/manten/i.test(tipo)) return POR_CLAVE.mantenimiento;
  if (/devoluci/i.test(tipo)) return POR_CLAVE.devolucion;
  return POR_CLAVE.otro;
}

/** En un reemplazo, el módem al que reemplazó ({ num_sim, emai }) para verificar que se haya quitado; si no, null. */
export function modemAnteriorDe(row) {
  if (categoriaDe(row).clave !== "reemplazo") return null;
  const num_sim = String(row?.modem_afectado || "").trim();
  const emai = String(row?.emai_afectado || "").trim();
  return num_sim || emai ? { num_sim, emai } : null;
}
